<div class="modal-body">

    <div class="card-header">
        <div class="tool">
            <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
                <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
                [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
            </button>
       </div>
    </div>

    <div class="card-body">

        <div id="stepper2" class="bs-stepper">

            <div class="bs-stepper-header">
                <div class="step" [ngClass]="{'active': nextStepCode}" data-target="#test-l-1">
                    <button class="step-trigger" style="margin-left: 0;">
                        <span class="bs-stepper-circle" >1</span>
                        <span class="bs-stepper-label">Восстановление пароля</span>
                    </button>
                </div>
                <div class="line"></div>
                <div class="step" [ngClass]="{'active': nextStepPass}" data-target="#test-l-2">
                    <button class="step-trigger" disabled="nextStepCode">
                        <span class="bs-stepper-circle">2</span>
                        <span class="bs-stepper-label">Код подтверждения</span>
                    </button>
                </div>
                <div class="line"></div>
                <div class="step"data-target="#test-l-3">
                    <button class="step-trigger" style="margin-right: 0;" disabled="nextStepPass">
                        <span class="bs-stepper-circle" >3</span>
                        <span class="bs-stepper-label">Новый пароль</span>
                    </button>
                </div>
            </div>

            <div class="bs-stepper-content">
                <form [formGroup]="formForgPass">
                    
                    <div id="test-l-1" class="content">
                        <!-- <div class="row"> -->
                            <!-- <div class="col-12"> -->
                                <div class="titel-content">
                                    <span class="titel">
                                        Укажите адрес e-mail для отправки кода сброса пароля
                                    </span>
                                </div>
                                <div class="form-inner">
                                    <div class="form-group">
                                        <div class="form-content input-group">
                                            <input type="text" class="form-control" placeholder="Введите адрес e-mail" formControlName="confirmation_email" autocomplete="off">
                                            <div *ngIf="errorMessages">
                                                <div *ngFor="let item of errorMessages.confirmation_email">
                                                    <div class="text-error" *ngIf="validation('confirmation_email', item.type)">
                                                        {{ item.message | translate: item.options }}
                                                    </div>
                                                </div>
                                            </div>   
                                        </div>
                                    </div>
                                </div>

                            <!-- </div> -->
                        <!-- </div> -->
                        <div class="stepper-btn-box btn-pos">
                            <button (click)="activeModal.dismiss(false)" class="btn btn-light btn-sm prev-step btn-step">{{ 'Отмена' | translate}}</button>
                            <button (click)="nextStep(); checkMail()" class="btn btn-primary btn-sm btn-step" [disabled]="formForgPass.controls.confirmation_email.invalid" >{{ 'PROCEED' | translate }}</button>
                            <!-- <button type="button" class="btn btn-light btn-sm" (click)="activeModal.dismiss()">{{ 'CLOSE' | translate}}</button> -->
                        </div>
                    </div>
    
                    <div id="test-l-2" class="content">
                        <!-- <div class="row"> -->
                            <!-- <div class="col-12"> -->
                                <div class="titel-content">
                                    <span class="titel">
                                        На вашу почту <span><a class="titel-link" target="_blank" href="https://mail.google.com/">{{confirmation_email}}</a></span> был отправлен код подтверждения
                                    </span>
                                </div>
                                <div class="form-inner">
                                    <div class="form-group">
                                        <div class="form-content input-group">
                                            <input type="text" class="form-control" id="confirmation_code" placeholder="Введите код подтверждения" formControlName="confirmation_code">
                                            <div *ngIf="errorMessages">
                                                <div *ngFor="let item of errorMessages.confirmation_code">
                                                    <div class="text-error" *ngIf="validation('confirmation_code', item.type)">
                                                            {{ item.message | translate: item.options }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            <!-- </div> -->
                        <!-- </div> -->
    
                        <div class="stepper-btn-box  btn-pos">
                            <button (click)="prevStep()" class="btn btn-light btn-sm prev-step btn-step">{{ 'BACK' | translate}}</button>
                            <button (click)="checkRegistration()" class="btn btn-primary btn-sm btn-step" [disabled]="formForgPass.controls.confirmation_code.invalid">{{ 'PROCEED' | translate }}</button>
                            <!-- <button type="button" class="btn btn-light btn-sm" (click)="activeModal.dismiss()">{{ 'CLOSE' | translate}}</button> -->
                        </div>
                    </div>
    
                    <div id="test-l-3" class="content">
                        <div class="form-group">
                            <div class="titel-content">
                                <span class="titel">
                                Введите новый пароль
                                </span>
                            </div>
                            <div class="form-inner">
                                <div class="form-group">
                                    <div class="form-content input-group">
                                        <input type="text" class="form-control" id="password" placeholder="Введите новый пароль" formControlName="password">
                                        <div *ngIf="errorMessages">
                                            <div *ngFor="let item of errorMessages.password">
                                                <div class="text-error" *ngIf="validation('password', item.type)">
                                                    {{ item.message | translate: item.options }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
   
                        </div>
        
                        <div class="form-group">
                            <div class="titel-content">
                                <span class="titel">
                                    Подтвердите пароль
                                </span>
                            </div>
                            <div class="form-inner">
                                <div class="form-group">
                                    <div class="form-content input-group">
                                        <input type="text" class="form-control" id="confirm_password" placeholder="Введите новый пароль повторно" formControlName="confirm_password">
                                        <div *ngIf="errorMessages">
                                            <div *ngFor="let item of errorMessages.confirm_password">
                                                <div class="text-error" *ngIf="validation('confirm_password', item.type)">
                                                    {{ item.message | translate: item.options }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="stepper-btn-box btn-pos">
                            <button (click)="prevStep()" class="btn btn-light btn-sm prev-step btn-step">{{ 'BACK' | translate }}</button>
                            <button (click)="resetPass()" class="btn btn-primary btn-sm prev-step btn-step">Подтвердить</button>
                            <!-- <button type="button" class="btn btn-light btn-sm" (click)="activeModal.dismiss()">{{ 'CLOSE' | translate}}</button> -->
                        </div>
                    </div>

                </form>

            </div>


        </div>

    </div>

</div>